import React,{ Component } from 'react';
import NavBar from './navbar';

export default class GrayNavBar  extends NavBar {

    constructor(props){
        super(props,true);
    }

}




// WEBPACK FOOTER //
// src/components/layout/gray-navbar.js